var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',[_c('v-tab',{attrs:{"to":"/dynamic_pricing/import_log"}},[_vm._v("アップロード履歴")]),_c('v-tab',{attrs:{"to":"/dynamic_pricing/discount"}},[_vm._v("値引きデータ")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }